import React from 'react'
import { StyleSheet, View } from 'react-native'
import { useTheme } from '@react-navigation/native'
import { Theme } from '@theme'
import { Icon } from '../atoms'

export type SelectionIndicatorProps = {
  isSelected: boolean
}

export const SelectionIndicator = ({
  isSelected = false,
}: SelectionIndicatorProps): React.ReactElement => {
  const theme = useTheme()
  const styles = getStyle(theme)

  return (
    <View style={isSelected ? styles.circleContainerSelected : styles.circleContainerUnSelected}>
      {isSelected && (
        <Icon name="check" color={theme.colors.white} size={theme.iconSize.extraSmall} />
      )}
    </View>
  )
}

const getStyle = (theme: Theme) =>
  StyleSheet.create({
    circleContainerSelected: {
      height: 20,
      width: 20,
      borderRadius: 10,
      backgroundColor: theme.colors.primary,
      alignItems: 'center',
      justifyContent: 'center',
    },
    circleContainerUnSelected: {
      height: 20,
      width: 20,
      borderRadius: 10,
      borderWidth: 2,
      borderColor: theme.colors.secondary,
    },
    circleWhite: {
      height: 10,
      width: 10,
      borderRadius: 5,
      backgroundColor: theme.colors.white,
    },
  })
